import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean | UrlTree {
    const profileData = localStorage.getItem('profileData');
    const microsite = localStorage.getItem('microsite');
    if (profileData && microsite) {
      return true;
    }
    return this.router.createUrlTree(['/otp']);
  }
}

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean | UrlTree {
    const profileData = localStorage.getItem('profileData');
    const microsite = localStorage.getItem('microsite');
    if (profileData && microsite) {
      return this.router.createUrlTree(['/index']);
    }
    return true;
  }
}